<div class="modal-content" style="width: 135%;height: 112%">
  <div class="modal-header" >
    <button type="button" class="close" aria-label="Close" (click)="closeBSF()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title" translate>GENERIC_CLOSE_SUBSCRIPTIONS
      <span *ngIf="!selectedOneItem && selectedItem?.length" translate>({{selectedItem?.length}} selected subscriptions)</span></h4>
  </div>
  <div class="modal-body">
    <div class="portlet-body">
           <span *ngIf="selectedOneItem ; else multiItems">
          <storever-header-subtitle [datas]="[
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: selectedOneItem?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: selectedOneItem.productName},
           {icon: 'fa-hdd fal', title: 'GENERIC_DEVICE_ID', name: selectedOneItem.deviceId}]"></storever-header-subtitle>
      </span>
      <ng-template #multiItems >
<!--        <div class="help-block error" *ngIf="!checkProductType()" translate>SUBSCRIPTION_SELECTED_WITH_DIFFERENT_PRODUCT</div>-->
        <div [ngClass]="selectedItem?.length > 6 ? 'scroll' : null" >
          <span *ngFor="let item of selectedItem let i = index " >
          <storever-header-subtitle [isAllowedRemove]="true" [datas]="[
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: item?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: item.productName},
           {icon: 'fa-hdd fal', title: 'GENERIC_DEVICE_ID', name: item.deviceId}]">
           <i class="fal fa-trash-alt" *ngIf="selectedItem?.length > 1" style="margin-top:6px" tooltip="{{ 'DELETE' | translate:locale.language}}" (click)="removeSubscription(i)"></i>
          </storever-header-subtitle>
      </span>
        </div>
      </ng-template >

      <form [formGroup]="myForm" style="width:100%" class="link_box">
        <storever-element-group
          [icon]="'fa-address-book'"
          [title]="'none'"
          [config]="formConfig.config"
          [form]="myForm">
        </storever-element-group>
      </form>
<!--      <label class="row col-sm-3 control-label" style="white-space: nowrap;margin-right: -4px;right: -6px;">-->
<!--        {{"REMOVE_PLAYER_IS_LOST_OR_SOLD" | translate:locale.language}}-->
<!--      </label>-->
<!--      <div class="col-sm-9">-->
<!--        <label class="control-label container pull" >-->
<!--          <input type="checkbox" class="form-check-input" [(ngModel)]="showHideReason"/>-->
<!--          <span class="checkmark"></span>-->
<!--        </label>-->
<!--      </div>-->

      <div  *ngIf="myForm.get('playerLost').value">
        <form [formGroup]="myForm" style="width:100%" class="link_box">
        <storever-element-group [config]="formConfigSoldOrLost.config"
                                [form]="formSoldOrLost"
                                [icon]="'fa-address-book'"
                                [title]="'none'">

        </storever-element-group>
        </form>
      </div>
      <br>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="formSoldOrLost.invalid"
            id="CONTRACT_LINK_MODAL_LINK"   (click)="send(myForm.value)"> {{'OK' | translate:locale.language}} </button>
    <button type="button" class="btn btn-default" (click)="closeBSF()">{{'CANCEL' | translate:locale.language}}</button>
  </div>
</div>
